import React from 'react';
import { ContainerDefaultProps } from "./Grille.types";
var Container = function (_a) {
    var children = _a.children, margeExterne = _a.margeExterne, className = _a.className, taille = _a.taille, Component = _a.as;
    var classContainer = 'fr-container';
    if (!Component) {
        Component = "div";
    }
    if (!margeExterne) {
        classContainer += '--fluid';
    }
    if (taille) {
        classContainer += " fr-container-".concat(taille);
    }
    if (className) {
        classContainer += " ".concat(className);
    }
    return (React.createElement(Component, { className: classContainer }, children));
};
Container.defaultProps = ContainerDefaultProps;
export default Container;
